import { render, staticRenderFns } from "./ItemType.vue?vue&type=template&id=199defab&scoped=true&"
import script from "./ItemType.vue?vue&type=script&lang=js&"
export * from "./ItemType.vue?vue&type=script&lang=js&"
import style0 from "./ItemType.vue?vue&type=style&index=0&id=199defab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "199defab",
  null
  
)

export default component.exports